import { Dispatch } from '@lumapps/redux/types';

import { actions as foActions } from '../frontOfficeSlice';

export const setSelectedCommunityId = (id: string) => (dispatch: Dispatch) => {
    dispatch(foActions.setSelectedCommunityId(id));
};
